var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-btn",on:{"click":function($event){return _vm.change()}}},[_vm._v("搜索")])
}
var staticRenderFns = []

export { render, staticRenderFns }